let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hjh1F")).then(() => parcelRequire('4tHNi'));